import { Component, OnInit } from '@angular/core';
import { environment as cenv } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public readonly URL = cenv.urlWeb;

  defensaConsumidor() {
    window.open('https://autogestion.produccion.gob.ar/consumidores', '_blank');
  }
}
